<template><DashboardPanel title="公告 / 异常提醒"><ul class="notice-list"><li v-for="item in notices" :key="item.key"><i :class="item.icon" :style="{background:item.color}"></i><span>{{item.text}}</span><time>{{item.time}}</time></li><li v-if="!notices.length" class="notice-empty"><span>当前查询期间暂无异常</span></li></ul></DashboardPanel></template>
<script>
import DashboardPanel from './DashboardPanel.vue'
import { formatNumber, toNumber } from '../dashboardFormat'

export default {
  name: 'NoticeAlerts',
  components: { DashboardPanel },
  props: { data: { type: Object, default: () => ({}) } },
  computed: {
    notices() {
      const rows = Array.isArray(this.data.items) ? this.data.items : []
      return rows.filter(item => toNumber(item.alertCount) > 0).map((item, index) => ({
        key: `${item.alertType || 'alert'}-${index}`,
        text: `${item.alertName || '异常'}：${formatNumber(item.alertCount)} 条`,
        time: '实时',
        color: item.alertType === 'repair_timeout' ? '#ef5b4d' : '#ed932b',
        icon: item.alertType === 'repair_timeout' ? 'el-icon-warning' : 'el-icon-warning-outline'
      }))
    }
  }
}
</script>
<style lang="scss" scoped>.notice-list{height:100%;margin:0;padding:5px 10px 8px;list-style:none}.notice-list li{display:grid;grid-template-columns:23px 1fr auto;align-items:center;height:28px;border-bottom:1px solid rgba(58,112,148,.27);color:#b8c8d4;font-size:11px}.notice-list li>span{text-align:left}.notice-list i{display:flex;align-items:center;justify-content:center;width:18px;height:18px;border-radius:50%;color:white;font-size:11px}.notice-list time{color:#8399a9;font-size:10px}.notice-list .notice-empty{display:flex;justify-content:center;color:#8399a9}</style>
